module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "maptype-container"
  }, [_c('ul', [_c('li', {
    staticClass: "mapTypeCard active",
    class: _vm.firstType.class,
    attrs: {
      "id": "normal"
    },
    on: {
      "click": function($event) {
        _vm.changeMapType(0)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.firstType.name))])]), _vm._v(" "), _c('li', {
    staticClass: "mapTypeCard",
    class: _vm.secondType.class,
    attrs: {
      "id": "earch"
    },
    on: {
      "click": function($event) {
        _vm.changeMapType(1)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.secondType.name))])]), _vm._v(" "), _c('li', {
    staticClass: "mapTypeCard",
    class: _vm.thirdType.class,
    attrs: {
      "id": "terrain"
    },
    on: {
      "click": function($event) {
        _vm.changeMapType(2)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.thirdType.name))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44bc794a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/map_module/maptool/mapType.vue
// module id = 80
// module chunks = 0